import React, { useEffect, useState } from 'react';
import { CheckboxControl } from "../../../../../components/controls";
import { InputField } from "../../../../../components/controls/InputField";
import '../../../../../styles/rsuite_override.css';
import { useValidationManager } from "../../../../../hooks/useValidation";
import ButtonControl from "../../../../../components/controls/ButtonControl";
import _ from 'lodash';
import Loading from '../../../../../components/Loading';
import globalAuthStateStore from "../../../../../stores/globalAuthStateStore";
import { VirtualLibrarianService } from '../../../../../services/VirtualLibrarianService';
import { useHookstate } from '@hookstate/core';
import ReactMarkdown from 'react-markdown';

const GuardrailDetails = ({ guardrailId, onSave, onCancel, onValidationErrors, onErrors, onLoadingError, onLoading }) => {

    const [itemData, setItemData] = useState({ UniqueId: guardrailId });
    const validationManager = useValidationManager(false, ['GUARDRAIL']);
    const [forceValidation, setForceValidation] = useState(false);
    const [saving, setSaving] = useState(false);

    const authStore = useHookstate(globalAuthStateStore);
    const vlService = React.useMemo(() => new VirtualLibrarianService(authStore), [authStore]);

    useEffect(() => {
        const screenData = sessionStorage.getItem('screen-data');
        const fetchGuardrail = async () => {
            if (onLoading)
                onLoading(true);
            const result = await vlService.getVirtualLibrarianGuardrail(guardrailId);
            if (result.Success && result.Data) {
                console.log('Guardrails fetched successfully:', result);
                setItemData(result.Data);
                saveItemInStorage(result.Data);
                onLoading(false);
            }
            else if (onLoadingError) {
                onLoadingError(result.DisplayMessage);
            }
            if (onLoading)
                onLoading(false);

        };
        if (screenData) {
            setItemData(JSON.parse(screenData));
        }
        else {
            if (vlService && guardrailId) {
                fetchGuardrail();
            }
            else {
                setItemData({ UniqueId: guardrailId, isActive: true, promptType: 'Custom' });
            }
        }
    }, [guardrailId]);

    const saveItemInStorage = (item) => {
        sessionStorage.setItem('screen-data', JSON.stringify(item));
    };

    const handleOnChange = (value, field) => {
        const updatedItemData = { ...itemData };
        updatedItemData[field] = value;
        saveItemInStorage(updatedItemData);
        setItemData(updatedItemData);
    }

    const handleOnSave = async () => {
        const errors = validationManager.checkIsGroupValid(itemData);
        const saveGuardrail = async () => {
            if (onSave)
                setSaving(true);
            const result = guardrailId ? await vlService.saveGuardrail(guardrailId, itemData) : await vlService.createGuardrail(itemData);
            if (result.Success && result.Data) {
                console.log('Guardrail saved successfully:', result);
                onSave(result.Data);
                setSaving(false);
            }
            else if (onErrors) {
                onErrors([result.DisplayMessage]);
                setSaving(false);
            }
        };

        if (errors.length === 0) {
            saveGuardrail(guardrailId, itemData);
        }
        else if (onValidationErrors) {
            onValidationErrors(errors);
            validationManager.setForceValidate(true);
            setForceValidation(true);
        }
    }

    const handleOnCancel = () => {
        if (onCancel) {
            onCancel();
        }
    }

    return <div className='control-box-wrapper'>
        {itemData && <div className='control-box'>
            <InputField title="Prompt Title" forceValidate={forceValidation} value={itemData?.promptTitle} onChange={handleOnChange} groupId={'GUARDRAIL'} placeholder={'Prompt Title'} maxLength={100} subTitle={"Enter the title of this system prompt."} fieldName="promptTitle" validationName="Guardrail_Title" />
            <InputField title="Prompt Content" forceValidate={forceValidation} value={itemData?.promptContent} onChange={handleOnChange} maxLength={8000} groupId={'GUARDRAIL'} subTitle={"Provide the content of the system prompt preferably in Markdown format."} type="textarea" fieldName="promptContent" validationName="Guardrail_Content" />
            <InputField title="Active?" value={itemData?.isActive} onChange={handleOnChange} groupId={'GUARDRAIL'} fieldName='isActive'>
                <CheckboxControl fieldName='isActive' />
            </InputField>            

            <div className='title-header'>
                <div className="title">Markdown Preview</div>
            </div>
            <div style={{ marginTop: '5px', border: '1px solid #ccc', padding: '20px', borderRadius: '4px', minHeight: '100px', backgroundColor: '#f9f9f9' }}>
                <ReactMarkdown>{itemData?.promptContent || '*No content provided*'}</ReactMarkdown>
            </div>

        </div>}
        <div className='screen-footer right'>
            <div className='btn-wrapper-left screen-footer__btn'><ButtonControl disabled={saving} type={'cancel'} onClick={handleOnCancel}>Cancel</ButtonControl></div>
            <div className='btn-wrapper-right screen-footer__btn'><ButtonControl loading={saving} type={'okay'} onClick={handleOnSave}>Save</ButtonControl></div>

        </div>
    </div>
}

export default GuardrailDetails;


